/// <reference types="@angular/localize" />

import '@govbr-ds/webcomponents/dist/loader';

import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// Locale pt-BR disponível para os pipes que o solicitam explicitamente (ex.: currency).
// Não altera o LOCALE_ID padrão do app.
registerLocaleData(localePt, 'pt-BR');
// import { environment } from './environments/environment';
// Initialize MSW in development mode
async function enableMocking() {
  // if (!environment.production) {
  //   const { worker } = await import('./mocks/browser');
  //   return worker.start();
  // }
  return Promise.resolve();
}


enableMocking().then(() => {
  bootstrapApplication(App, appConfig)
    .catch((err) => console.error(err));
});
